import { createSelector } from 'helpers/reselect'
import { GLOBAL_SEARCH_COMPONENT } from './constants'
import { getArrayObjectByParam } from 'helpers/utils'

export const getMainContentFromData = ({
  contents: [
    {
      mainContent
    } = {}
  ] = []
}) => mainContent

export const getRecordsAndSortOptionsFromData = createSelector(
  [getMainContentFromData],
  (mainContent) => {
    const [
      {
        rightContent: [
          {
            records,
            sortOptions,
            lastRecNum
          } = {}
        ] = []
      } = {}
    ] = getArrayObjectByParam({ array: mainContent, value: GLOBAL_SEARCH_COMPONENT })
    return ({ records, sortOptions, lastRecNum })
  }
)
